export default "__VITE_ASSET__CfPh9D75__"